import { Box, IconButton } from '@chakra-ui/react';
import { MdMoreVert } from 'react-icons/md';
import { FaArrowTurnUp } from 'react-icons/fa6';

import { TxReportTotal } from '@app/api/models';
import { TableColumn } from '@app/components/common/table';
import { Txt } from '@app/components/common';
import { Level } from '@app/api/models/structure';

import { TxNodeItem } from './types';
import { TxReportViewNode } from './components/node';

export const useColumns = ({ chain, levels, onItemClick, onMoveUpClick, onShowDetail }: { 
  chain: TxNodeItem[],
  levels: Level[],
  onItemClick: (item: TxNodeItem) => void
  onMoveUpClick: (item: TxNodeItem) => void
  onShowDetail: (item: TxNodeItem) => void
}): TableColumn<TxNodeItem>[] => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (name, { rowData, totalRows, rowIndex }) => {
          if (rowData.id === '-1') {
            return <Txt color='gray.500'>Итого</Txt>;
          }
          if (!chain.length) {
            return <TxReportViewNode
              data={rowData}
              isLastLevel={false}
              index={0}
              parentIndex={0}
              onItemClick={onItemClick}
            />;
          }
          const index = chain.findIndex(({ id, level }) => id === rowData.id && level.id === rowData.level.id);
          const isLastLevel = levels[levels.length - 1].value === rowData.level.id;
          const levelIndex = levels.findIndex(({ value }) => value === rowData.level.id);
          if (index !== -1) {
            const parentLevelIndex = index > 0 ? levels.findIndex(({ value }) => value === chain[index - 1].level.id) : -1; 

            return <TxReportViewNode               
              data={rowData}
              isLastLevel={false}
              index={levelIndex}
              parentIndex={parentLevelIndex}
              onItemClick={onMoveUpClick}
              linkUp={index > 0 ? 1 : undefined}
              linkDown
            />;
          }
          const parentLevelIndex = levels.findIndex(({ value }) => value === chain[chain.length - 1].level.id);  

          return <TxReportViewNode
            data={rowData}
            index={levelIndex}
            parentIndex={parentLevelIndex}
            isLastLevel={isLastLevel}
            onItemClick={onItemClick}
            linkUp={1}
            linkMore={totalRows > rowIndex + 2} 
          />;
        },
      },
    },
    {
      name: 'total',
      label: 'Установка',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: TxReportTotal) =>  {
          return <Box display='flex' alignItems='center' justifyContent='flex-start'>
            <Txt fontWeight='bold'>{value.installations}</Txt>
          </Box>;
        },
      },
    },
    {

      name: 'total',
      label: 'Демонтаж',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: TxReportTotal) =>  {
          return <Box display='flex' alignItems='center' justifyContent='flex-start'>
            <Txt fontWeight='bold'>{value.removals}</Txt>
          </Box>;
        },
      },
    },
    {

      name: 'total',
      label: 'Прирост',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: TxReportTotal) =>  {
          const gain = value.installations - value.removals;
          return <Box display='flex' alignItems='center' justifyContent='flex-start'>
            <Txt fontWeight='bold' color={gain === 0 ? 'gray.500' : gain > 0 ? 'green.500' : 'red.500'}>{gain}</Txt>
          </Box>;
        },
      },
    },
    // {
    //   name: 'total',
    //   label: '',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value: TxReportTotal, { rowData }) =>  {
    //       return <Box display='flex' alignItems='center'>
    //         <Box ml={1}>
    //           <IconButton aria-label='' onClick={() => onShowDetail(rowData)}>
    //             <MdMoreVert />
    //           </IconButton>
    //         </Box>
    //       </Box>;
    //     },
    //   },
    // }
  ];
};